// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {hasAuthor, isAuthorized, roles, getUserName, getTimeoutOtp, setTimeoutOtp, setPlayStatus} from './security/index'
import App from './App'
import router from './router'
import store from './store'
import helper from './helper'
import vueToast from 'vue-toast-notification'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Vuex from 'vuex';

Vue.config.productionTip = false

const plugin = {
  install () {
    Vue.prototype.$helper = helper
    Vue.prototype.$hasAuthor = hasAuthor
    Vue.prototype.$isAuthorized = isAuthorized
    Vue.prototype.$authRoles = roles()
    Vue.prototype.$getUserName = getUserName
    Vue.prototype.$getTimeoutOtp = getTimeoutOtp
    Vue.prototype.$setTimeoutOtp = setTimeoutOtp
    Vue.prototype.$setPlayStatus = setPlayStatus
  }
}

Vue.use(vueToast, {
  position: 'top-right',
  duration: 2500,
  dismissible: true
})
Vue.use(plugin)
Vue.use( CKEditor );
Vue.use(Vuex);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js